import AppHeaderDirective from 'directives/appHeader';
import appHeaderCtrl from 'directives/appHeader/controller';
//
import AppFooterDirective from 'directives/appFooter';
import appFooterCtrl from 'directives/appFooter/controller';
//
import BookingCardDirective from 'directives/bookingCard';
import bookingCardCtrl from 'directives/bookingCard/controller';
//
import BookingStatusDirective from 'directives/bookingStatus';
import bookingStatusCtrl from 'directives/bookingStatus/controller';
//
import CheckoutPreviewDirective from 'directives/checkoutPreview';
import checkoutPreviewCtrl from 'directives/checkoutPreview/controller';
//
import CityPickerDirective from 'directives/cityPicker';
import cityPickerCtrl from 'directives/cityPicker/controller';
//
import CompleteProfileDirective from 'directives/completeProfile';
import completeProfileDirectiveCtrl from 'directives/completeProfile/controller';
//
import ConciergeDirective from 'directives/concierge';
import conciergeCtrl from 'directives/concierge/controller';
//
import ConciergeChatDirective from 'directives/conciergeChat';
import conciergeChatCtrl from 'directives/conciergeChat/controller';
//
import ConciergeSignupDirective from 'directives/conciergeSignup';
import conciergeSignupCtrl from 'directives/conciergeSignup/controller';
//
import ContactOptionsDirective from 'directives/contactOptions';
import contactOptionsCtrl from 'directives/contactOptions/controller';
//
import CreditCardPreviewDirective from 'directives/creditCardPreview';
import creditCardPreviewCtrl from 'directives/creditCardPreview/controller';
//
import CuratedListCardDirective from 'directives/curatedListCard';
import curatedListCardCtrl from 'directives/curatedListCard/controller';
//
import CuratedListEventCardDirective from 'directives/curatedListEventCard';
import curatedListEventCardCtrl from 'directives/curatedListEventCard/controller';
//
import CuratedListItemCardDirective from 'directives/curatedListItemCard';
import curatedListItemCardCtrl from 'directives/curatedListItemCard/controller';
//
import VenueCardDirective from 'directives/venueCard';
import venueCardCtrl from 'directives/venueCard/controller';
//
import EventCardDirective from 'directives/eventCard';
import eventCardCtrl from 'directives/eventCard/controller';
//
import EventListCardDirective from 'directives/eventListCard';
import eventListCardCtrl from 'directives/eventListCard/controller';
//
import RichVenueCardDirective from 'directives/richVenueCard';
import richVenueCardCtrl from 'directives/richVenueCard/controller';
//
import RichEventCardDirective from 'directives/richEventCard';
import richEventCardCtrl from 'directives/richEventCard/controller';
//
import FavoriteToggleDirective from 'directives/favoriteToggle';
import favoriteToggleCtrl from 'directives/favoriteToggle/controller';
//
import LoginDirective from 'directives/login';
import loginDirectiveCtrl from 'directives/login/controller';
//
import LoginEmailDirective from 'directives/loginEmail';
import loginEmailDirectiveCtrl from 'directives/loginEmail/controller';
//
import LoginFacebookDirective from 'directives/loginFacebook';
import loginFacebookDirectiveCtrl from 'directives/loginFacebook/controller';
//
import MembershipCardDirective from 'directives/membershipCard';
import membershipCardCtrl from 'directives/membershipCard/controller';
//
import PaymentProfileDirective from 'directives/paymentProfile';
import paymentProfileCtrl from 'directives/paymentProfile/controller';
//
import PromoBarDirective from 'directives/promoBar';
import promoBarCtrl from 'directives/promoBar/controller';
//
import ReferralBlockDirective from 'directives/referralBlock';
import referralBlockCtrl from 'directives/referralBlock/controller';
//
import SearchDirective from 'directives/search';
import searchDirectiveCtrl from 'directives/search/controller';
//
import ShareBarDirective from 'directives/shareBar';
import shareBarCtrl from 'directives/shareBar/controller';
//
import SmartBannerDirective from 'directives/smartBanner';
import smartBannerCtrl from 'directives/smartBanner/controller';
//
import SmsDownloadLinkDirective from 'directives/smsDownloadLink';
import smsDownloadLinkCtrl from 'directives/smsDownloadLink/controller';
//
import VenueRatingDirective from 'directives/venueRating';
import venueRatingCtrl from 'directives/venueRating/controller';
//
import CookieBannerDirective from 'directives/cookieBanner';
import cookieBannerCtrl from 'directives/cookieBanner/controller';
//
import InventoryListItemDirective from 'directives/inventoryListItem';
import SelectedInventoryDirective from 'directives/selectedInventory';
//
import MetaDirective from 'directives/meta';
import AutoFocusDirective from 'directives/autofocus';
import BgImgDirective from 'directives/bgImg';
import BookingGuestsDirective from 'directives/bookingGuests';
import BookingItemsDirective from 'directives/bookingItems';
import BtnSelectDirective from 'directives/btnSelect';
import CountdownDirective from 'directives/countdown';
import DateRangePickerSingleDirective from 'directives/dateRangePickerSingle';
import ImgUploadDirective from 'directives/imgUpload';
import InventoryIconDirective from 'directives/inventoryIcon';
import LoadingDirective from 'directives/loading';
import LoadingDotsDirective from 'directives/loadingDots';
import NgEnterDirective from 'directives/ngEnter';
import PhoneNumberDirective from 'directives/phoneNumber';
import ReadmoreDirective from 'directives/readmore';
import SlideDownDirective from 'directives/slideDown';
import SoundcloudPlayerDirective from 'directives/soundcloudPlayer';
import VenueTypeDirective from 'directives/venueType';
import ContactUsDirective from 'directives/contactUs';

function init(app) {
  if (!app) throw new Error('app is required');

  app.directive('appHeader', AppHeaderDirective);
  app.controller('appHeaderCtrl', appHeaderCtrl);
  //
  app.directive('appFooter', AppFooterDirective);
  app.controller('appFooterCtrl', appFooterCtrl);
  //
  app.directive('bookingCard', BookingCardDirective);
  app.controller('bookingCardCtrl', bookingCardCtrl);
  //
  app.directive('bookingStatus', BookingStatusDirective);
  app.controller('bookingStatusCtrl', bookingStatusCtrl);
  //
  app.directive('checkoutPreview', CheckoutPreviewDirective);
  app.controller('checkoutPreviewCtrl', checkoutPreviewCtrl);
  //
  app.directive('cityPicker', CityPickerDirective);
  app.controller('cityPickerCtrl', cityPickerCtrl);
  //
  app.directive('completeProfile', CompleteProfileDirective);
  app.controller('completeProfileDirectiveCtrl', completeProfileDirectiveCtrl);
  //
  app.directive('concierge', ConciergeDirective);
  app.controller('conciergeCtrl', conciergeCtrl);
  //
  app.directive('conciergeChat', ConciergeChatDirective);
  app.controller('conciergeChatCtrl', conciergeChatCtrl);
  //
  app.directive('conciergeSignup', ConciergeSignupDirective);
  app.controller('conciergeSignupCtrl', conciergeSignupCtrl);
  //
  app.directive('contactOptions', ContactOptionsDirective);
  app.controller('contactOptionsCtrl', contactOptionsCtrl);
  //
  app.directive('creditCardPreview', CreditCardPreviewDirective);
  app.controller('creditCardPreviewCtrl', creditCardPreviewCtrl);
  //
  app.directive('curatedListCard', CuratedListCardDirective);
  app.controller('curatedListCardCtrl', curatedListCardCtrl);
  //
  app.directive('curatedListEventCard', CuratedListEventCardDirective);
  app.controller('curatedListEventCardCtrl', curatedListEventCardCtrl);
  //
  app.directive('curatedListItemCard', CuratedListItemCardDirective);
  app.controller('curatedListItemCardCtrl', curatedListItemCardCtrl);
  //
  app.directive('venueCard', VenueCardDirective);
  app.controller('venueCardCtrl', venueCardCtrl);
  //
  app.directive('eventListCard', EventListCardDirective);
  app.controller('eventListCardCtrl', eventListCardCtrl);
  //
  app.directive('eventCard', EventCardDirective);
  app.controller('eventCardCtrl', eventCardCtrl);
  //
  app.directive('richVenueCard', RichVenueCardDirective);
  app.controller('richVenueCardCtrl', richVenueCardCtrl);
  //
  app.directive('richEventCard', RichEventCardDirective);
  app.controller('richEventCardCtrl', richEventCardCtrl);
  //
  app.directive('favoriteToggle', FavoriteToggleDirective);
  app.controller('favoriteToggleCtrl', favoriteToggleCtrl);
  //
  app.directive('login', LoginDirective);
  app.controller('loginDirectiveCtrl', loginDirectiveCtrl);
  //
  app.directive('loginEmail', LoginEmailDirective);
  app.controller('loginEmailDirectiveCtrl', loginEmailDirectiveCtrl);
  //
  app.directive('loginFacebook', LoginFacebookDirective);
  app.controller('loginFacebookDirectiveCtrl', loginFacebookDirectiveCtrl);
  //
  app.directive('membershipCard', MembershipCardDirective);
  app.controller('membershipCardCtrl', membershipCardCtrl);
  //
  app.directive('paymentProfile', PaymentProfileDirective);
  app.controller('paymentProfileCtrl', paymentProfileCtrl);
  //
  app.directive('promoBar', PromoBarDirective);
  app.controller('promoBarCtrl', promoBarCtrl);
  //
  app.directive('referralBlock', ReferralBlockDirective);
  app.controller('referralBlockCtrl', referralBlockCtrl);
  //
  app.directive('search', SearchDirective);
  app.controller('searchDirectiveCtrl', searchDirectiveCtrl);
  //
  app.directive('shareBar', ShareBarDirective);
  app.controller('shareBarCtrl', shareBarCtrl);
  //
  app.directive('smartBanner', SmartBannerDirective);
  app.controller('smartBannerCtrl', smartBannerCtrl);
  //
  app.directive('smsDownloadLink', SmsDownloadLinkDirective);
  app.controller('smsDownloadLinkCtrl', smsDownloadLinkCtrl);
  //
  app.directive('venueRating', VenueRatingDirective);
  app.controller('venueRatingCtrl', venueRatingCtrl);
  //
  app.directive('cookieBanner', CookieBannerDirective);
  app.controller('cookieBannerCtrl', cookieBannerCtrl);
  //
  app.directive('inventoryListItem', InventoryListItemDirective);
  app.directive('selectedInventory', SelectedInventoryDirective);
  //
  app.directive('meta', MetaDirective);
  app.directive('autoFocus', AutoFocusDirective);
  app.directive('bgImg', BgImgDirective);
  app.directive('bookingGuests', BookingGuestsDirective);
  app.directive('bookingItems', BookingItemsDirective);
  app.directive('btnSelect', BtnSelectDirective);
  app.directive('countdown', CountdownDirective);
  app.directive('dateRangePickerSingle', DateRangePickerSingleDirective);
  app.directive('imgUpload', ImgUploadDirective);
  app.directive('inventoryIcon', InventoryIconDirective);
  app.directive('loading', LoadingDirective);
  app.directive('loadingDots', LoadingDotsDirective);
  app.directive('ngEnter', NgEnterDirective);
  app.directive('phoneNumber', PhoneNumberDirective);
  app.directive('readMore', ReadmoreDirective);
  app.directive('slideDown', SlideDownDirective);
  app.directive('soundcloudPlayer', SoundcloudPlayerDirective);
  app.directive('venueType', VenueTypeDirective);
  app.directive('contactUs', ContactUsDirective);
}

export default {
  init
};



// WEBPACK FOOTER //
// ./src/directives/index.js